import React from 'react'
import ErrorMessage from '../ErrorMessage/component.jsx'

export default function Unauthorized() {
  return <ErrorMessage statusCode={401} />
}
